import {Translate} from "../Translate";

const routesConfig = [
    {
        id: 'dashboard',
        title: Translate.dashboard,
        type: 'item',
        icon: 'dashboard',
        url: '/dashboard',
    },
    {
        id: 'tickets',
        title: Translate.tickets,
        type: 'item',
        icon: 'chat',
        url: '/tickets',
        roles: ['user','supplier','agent'],
        feature:'tickets'
    },
    {
        id: 'agent',
        title: Translate.your_commissions,
        type: 'item',
        icon: 'credit_score',
        url: '/agent',
        roles: ['agent'],
        feature:'agent'
    },
    {
        id: 'orders',
        roles: ['user','supplier'],
        title: Translate.ordersList,
        type: 'item',
        icon: 'shopping_cart',
        url: '/my-orders',
    },
    {
        id: 'wallet',
        title: Translate.myWallet,
        type: 'item',
        icon: 'account_balance_wallet',
        url: '/wallet/view',
        feature: 'wallet'
    },

    {
        id: 'account',
        title: Translate.account,
        type: 'group',
    },
    {
        id: 'addresses',
        title: Translate.addresses,
        type: 'item',
        icon: 'map',
        url: '/account/address',
    },
    {
        id: 'settings',
        title: Translate.account,
        type: 'item',
        icon: 'person',
        url: '/account/details',
    },

    {
        id: 'verification',
        title: Translate.verificationDetails,
        icon: 'credit_card',
        type: 'item',
        url: '/account/verification',
        feature:"wallet"
    },
    {
        id: 'password',
        title: Translate.changePassword,
        icon: 'password',
        type: 'item',
        url: '/account/password',
    },

];
export default routesConfig;
